// src/App.tsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';

import ArticlesTab from './components/Articles';
import AddArticle from './components/AddArticle';
import NotificationsTab from './components/Notifications';
import Navbar from './components/Navbar';
import ArticleDetails from './components/ArticleDetails';
import NotificationDetails from './components/NotificationsDetails';
import SendNotification from './components/SendNotification';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoutes';
import UpdateArticle from './components/UpdateArticle';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <>
    <ToastContainer />
    <Router>
      <Container>
        {isAuthenticated && <Navbar onLogout={()=>setIsAuthenticated(false)}/>}

        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/articles" />
              ) : (
                <Login onLoginSuccess={() => setIsAuthenticated(true)} />
              )
            }
          />

          {/* Protected routes */}
          <Route
            path="/articles"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <ArticlesTab />
              </ProtectedRoute>
            }
          />
          <Route
            path="/articles/add"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AddArticle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/articles/:id"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <ArticleDetails />
              </ProtectedRoute>
            }
          />

           <Route
            path="/articles/:id/edit"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <UpdateArticle />
              </ProtectedRoute>
            }
          />

          <Route
            path="/notifications"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <NotificationsTab />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/send-notification"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <SendNotification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/:id"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <NotificationDetails />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="*" element={<Navigate to={isAuthenticated ? "/articles" : "/login"} />} />
        </Routes>
      </Container>
    </Router>
    </>
  );
}

export default App;
